//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { assign, cloneDeep, getSeconds, dealPosiData, matomofn } from '~/assets/js/utils.js'
export default {
  async asyncData ({ query, $api }) {
    const { symbol = '' } = query
    try {
      const { OpenOrderRate: openRate = {}, PriceStepList: priceStep = [] } = await $api.holdPosi.holdDistributionServer({ symbol: symbol || 'EURUSD' })
      return {
        ...(symbol ? { selectVal: symbol } : {}),
        pageData: dealPosiData(openRate, priceStep, 4)
      }
    } catch (err) {}
  },
  data () {
    return {
      optionList: [ // 下拉选择列表
        { label: 'EUR / USD', value: 'EURUSD' },
        { label: 'GBP / USD', value: 'GBPUSD' },
        { label: 'AUD / USD', value: 'AUDUSD' },
        { label: 'NZD / USD', value: 'NZDUSD' },
        { label: 'USD / JPY', value: 'USDJPY' },
        { label: 'USD / CAD', value: 'USDCAD' },
        { label: 'USD / CHF', value: 'USDCHF' },
        { label: 'XAU / USD', value: 'XAUUSD' }
      ],
      selectVal: 'EURUSD', // 下拉选择选中项
      pageData: { // 页面数据
        sellWinXScale: [],
        sellWinYScaleArray: [],
        buyWinXScale: [],
        buyWinYScaleArray: [],
        sellLossXScale: [],
        sellLossYScaleArray: [],
        buyLossXScale: [],
        buyLossYScaleArray: [],
        x_coordinate: [],
        y_coordinate: [],
        cutTxt: ''
      },
      currTime: getSeconds(), // 当前时间
      pageEnterTime: null // 页面进入时间
    }
  },
  head () {
    return {
      title: this.$t('19820'),
      meta: [
        { name: 'Keywords', content: this.$t('TYY_000648') },
        { name: 'Description', content: this.$t('19821') }
      ]
    }
  },
  computed: {
    // 面包屑导航——首页
    breadHost () {
      return this.$store.getters.breadHome
    },
    // 图表配置项公用部分
    commonConf () {
      return (isRotate = false) => ({
        grid: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        },
        xAxis: {
          type: 'value',
          position: 'bottom',
          splitLine: { show: false },
          axisLabel: {
            formatter: params => Math.abs(params),
            color: '#333333'
          }
        },
        yAxis: {
          type: 'category',
          position: 'left',
          max: 14,
          axisTick: { show: false },
          axisLabel: { show: false },
          axisLine: { show: false },
          splitLine: { show: false }
        },
        tooltip: {
          backgroundColor: 'rgba(0,0,0,0.7)',
          borderColor: 'rgba(0,0,0,0.2)',
          textStyle: {
            color: '#FFFFFF'
          },
          formatter: params => `<div class=${isRotate ? 'sides-pop-rotate' : ''}><span class="sides-pop" style="background:${params.color};"></span>price：${params.name}<br /><span class="sides-pop" style="background:${params.color};"></span>rate：${Math.abs(params.data)}%</div>`
        },
        series: [{
          type: 'bar',
          barWidth: 10,
          label: { show: false }
        }]
      })
    }
  },
  watch: {
    // 监听屏幕宽度的变化
    '$store.state.screenWidth' (newV) {
      this.listenBarChart()
    }
  },
  mounted () {
    // 记录页面进入时间
    this.pageEnterTime = Date.now()
    // 监听页面关闭事件
    window.addEventListener('beforeunload', this.trackPageTime)
    this.setBar1(this.pageData)
  },
  beforeDestroy () {
    // 移除事件监听器
    window.removeEventListener('beforeunload', this.trackPageTime)
    // 执行页面时间统计
    this.trackPageTime()
    clearTimeout(this.againTimer)
    this.upLeft?.clear() // 清空当前实例
    this.upRight?.clear()
    this.downLeft?.clear()
    this.downRight?.clear()
    this.upLeft?.dispose() // 销毁图表
    this.upRight?.dispose()
    this.downLeft?.dispose()
    this.downRight?.dispose()
    this.upLeft = this.upRight = this.downLeft = this.downRight = null
  },
  methods: {
    // 页面时间统计
    trackPageTime () {
      if (this.pageEnterTime) {
        const exitTime = Date.now()
        matomofn('Cloud_Position_Time', {
          af_Enter: this.pageEnterTime,
          af_Exit: exitTime
        }, this.$store.state, this.$cookies)
      }
    },
    // 下拉选择改变时
    async changeSymbol (value = '') {
      try {
        const { OpenOrderRate: openRate = {}, PriceStepList: priceStep = [] } = await this.$api.holdPosi.holdDistributionClient({ symbol: value })
        assign(this.pageData, dealPosiData(openRate, priceStep, 4))
        clearTimeout(this.againTimer)
        this.setBar1(this.pageData)
      } catch (err) {}
    },
    // 绘制左上角的柱状图
    setBar1 (data = {}) {
      if (!this.upLeft) this.upLeft = this.$echarts.init(document.getElementById('up-left'))
      const option = cloneDeep(this.commonConf())
      assign(option.tooltip, {
        position: point => [point[0], point[1]]
      })
      assign(option.xAxis, {
        min: data?.x_coordinate[0],
        max: 0
      })
      assign(option.yAxis, {
        position: 'right',
        data: data?.sellWinYScaleArray
      })
      assign(option.series[0], {
        itemStyle: { color: this.isRedUp() ? '#EB4654' : '#1FBB95' },
        data: data?.sellWinXScale
      })
      this.upLeft?.clear()
      this.upLeft?.setOption(option)
      this.setBar2(data)
    },
    // 绘制右上角的柱状图
    setBar2 (data = {}) {
      if (!this.upRight) this.upRight = this.$echarts.init(document.getElementById('up-right'))
      const option = cloneDeep(this.commonConf())
      assign(option.tooltip, {
        confine: true
      })
      assign(option.xAxis, {
        min: 0,
        max: Math.abs(data?.x_coordinate[0])
      })
      assign(option.yAxis, {
        data: data?.buyLossYScaleArray
      })
      assign(option.series[0], {
        itemStyle: { color: this.isRedUp() ? '#1FBB95' : '#EB4654' },
        data: data?.buyLossXScale
      })
      this.upRight?.clear()
      this.upRight?.setOption(option)
      this.setBar3(data)
    },
    // 绘制左下角的柱状图
    setBar3 (data = {}) {
      if (!this.downLeft) this.downLeft = this.$echarts.init(document.getElementById('down-left'))
      const option = cloneDeep(this.commonConf(true))
      assign(option.tooltip, {
        confine: true
      })
      assign(option.xAxis, {
        min: data?.x_coordinate[0],
        max: 0
      })
      assign(option.yAxis, {
        data: data?.buyWinYScaleArray
      })
      assign(option.series[0], {
        itemStyle: { color: this.isRedUp() ? '#EB4654' : '#1FBB95' },
        data: data?.buyWinXScale
      })
      this.downLeft?.clear()
      this.downLeft?.setOption(option)
      this.setBar4(data)
    },
    // 绘制右下角的柱状图
    setBar4 (data = {}) {
      if (!this.downRight) this.downRight = this.$echarts.init(document.getElementById('down-right'))
      const option = cloneDeep(this.commonConf(true))
      assign(option.xAxis, {
        min: 0,
        max: Math.abs(data?.x_coordinate[0])
      })
      assign(option.yAxis, {
        position: 'right',
        data: data?.sellLossYScaleArray
      })
      assign(option.series[0], {
        itemStyle: { color: this.isRedUp() ? '#1FBB95' : '#EB4654' },
        data: data?.sellLossXScale
      })
      this.downRight?.clear()
      this.downRight?.setOption(option)
      this.againTimer = setTimeout(() => {
        this.setBar1(data)
        this.currTime = getSeconds() // 当前时间
      }, 10000)
    },
    // 监听图表的大小变化
    listenBarChart () {
      this.upLeft?.resize()
      this.upRight?.resize()
      this.downLeft?.resize()
      this.downRight?.resize()
    }
  }
}
